import React from 'react';
import styled from 'styled-components';

interface Props {
  onClose: () => void;
  children: React.ReactNode;
}

function CenterModal({ onClose, children }: Props) {
  return (
    <ModalOverlay
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }}
    >
      <ModalContainer
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {children}
      </ModalContainer>
    </ModalOverlay>
  );
}

export default CenterModal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000085;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContainer = styled.div`
  width: 328px;
  background-color: #ffffff;
  overflow: hidden;
  border-radius: 24px;
`;
